import { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { ApplicationConfigurationDto } from '@unistocks/proxy/axios-client';
import {
  abpApplicationConfigurationGetQueryKey,
  useAbpApplicationConfigurationGetQuery
} from '@unistocks/proxy/axios-client/AbpApplicationConfigurationQuery';

type UseApplicationConfigurationOptions<TSelect = ApplicationConfigurationDto> = Omit<
  UseQueryOptions<ApplicationConfigurationDto, unknown, TSelect, QueryKey>,
  'queryKey'
>;

export const APP_CONFIG_QUERY_KEY = abpApplicationConfigurationGetQueryKey(false);
export const useApplicationConfiguration = <T = ApplicationConfigurationDto>(
  options?: UseApplicationConfigurationOptions<T>
) => useAbpApplicationConfigurationGetQuery(false, options);
